import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import MainMenuItem from './mainMenuItem';
import AdminMenu from './adminMenu';
import getNavItems from './navItems';
import appHistory from '../../utils/appHistory';
const FixedHeader = ({
  user,
  cabinets: _cabinets = [],
  dashboards: _dashboards = [],
  settingsLoaded
}) => {
  var _navMenuItems$;
  const {
    pathname
  } = useLocation();
  const showIcons = true; // Top nav always shows icons (layout+mode selector controls shell/theme)

  const navMenuItems = [];
  let fileCabinetAvailable = false;
  const items = getNavItems({
    user,
    cabinets: _cabinets,
    dashboards: _dashboards
  });
  items.forEach(({
    key,
    className,
    href,
    icon,
    label
  }) => {
    if (key === 'reportsTab') fileCabinetAvailable = true;
    const path = href.replace('/#', '');
    const active = pathname.startsWith(path);
    navMenuItems.push(/*#__PURE__*/React.createElement(MainMenuItem, {
      className: className,
      key: key,
      href: href,
      glyph: showIcons ? icon : '',
      title: label,
      active: active
    }));
  });
  navMenuItems.push(/*#__PURE__*/React.createElement(AdminMenu, {
    key: "admin"
  }));

  // If the file cabinet is not available redirect to the first visible tab. This could be
  // implemented at the route level, but the header is the only component with knowledge of
  // what navigation elements are available.
  const firstNavHref = (_navMenuItems$ = navMenuItems[0]) === null || _navMenuItems$ === void 0 || (_navMenuItems$ = _navMenuItems$.props) === null || _navMenuItems$ === void 0 ? void 0 : _navMenuItems$.href;
  const shouldRedirect = !fileCabinetAvailable && settingsLoaded && Boolean(firstNavHref) && (pathname === '/' || pathname === '/logout');
  useEffect(() => {
    if (!shouldRedirect) {
      return;
    }
    appHistory.replace(firstNavHref.replace('/#', ''));
  }, [shouldRedirect, firstNavHref, pathname]);
  return navMenuItems;
};
FixedHeader.propTypes = {
  user: PropTypes.shape({
    permissions: PropTypes.shape({
      general: PropTypes.arrayOf(PropTypes.string)
    })
  }).isRequired,
  cabinets: PropTypes.arrayOf(PropTypes.shape({
    identifier: PropTypes.string,
    title: PropTypes.string,
    denyPermissions: PropTypes.arrayOf(PropTypes.string),
    allowPermissions: PropTypes.arrayOf(PropTypes.string),
    client: PropTypes.shape({
      web: PropTypes.shape({
        layout: PropTypes.shape({
          superset: PropTypes.string
        }),
        icon: PropTypes.string,
        tabGroup: PropTypes.shape({
          identifier: PropTypes.string
        })
      })
    })
  })),
  dashboards: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string
  })),
  settingsLoaded: PropTypes.bool.isRequired
};
export default FixedHeader;